import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight, Instagram, Facebook } from "lucide-react";
import { COMPANY } from "../lib/data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A192F] text-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="text-xs uppercase tracking-[0.3em] text-[#C5A059] mb-5">Let's build together</p>
            <h3 className="font-heading text-3xl sm:text-4xl font-bold leading-tight">
              Ready to start your<br />
              <span className="text-[#C5A059]">next project?</span>
            </h3>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="mt-8 inline-flex items-center gap-3 border border-[#C5A059] text-[#C5A059] px-7 py-3.5 text-sm tracking-wide hover:bg-[#C5A059] hover:text-[#0A192F] transition-colors duration-300"
            >
              Get in Touch <ArrowUpRight size={16} />
            </Link>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-white/50 mb-5">Site</p>
            <ul className="space-y-3 text-sm">
              {[
                ["Home", "/"],
                ["About", "/about"],
                ["Services", "/services"],
                ["Projects", "/projects"],
                ["Contact", "/contact"],
              ].map(([l, h]) => (
                <li key={l}>
                  <Link to={h} className="text-white/80 hover:text-[#C5A059] transition-colors">{l}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.3em] text-white/50 mb-5">Reach Us</p>
            <ul className="space-y-3 text-sm text-white/80">
              {COMPANY.phones.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <Phone size={15} className="mt-1 text-[#C5A059] shrink-0" />
                  <a href={`tel:${p.replace(/\s+/g, "")}`}>{p}</a>
                </li>
              ))}
              <li className="flex items-start gap-3">
                <Mail size={15} className="mt-1 text-[#C5A059] shrink-0" />
                <div className="flex flex-col gap-1">
                  {COMPANY.emails.map((e) => (
                    <a key={e} href={`mailto:${e}`} className="break-all hover:text-[#C5A059] transition-colors">{e}</a>
                  ))}
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={15} className="mt-1 text-[#C5A059] shrink-0" />
                <span className="leading-relaxed whitespace-pre-line">{COMPANY.branch.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col lg:flex-row justify-between gap-6 text-xs text-white/55">
          <div className="flex flex-col gap-2">
            <p>© {new Date().getFullYear()} Alex Interiors. All rights reserved.</p>
            <p className="tracking-wider">{COMPANY.tagline} · Kolkata · Pan-India Execution</p>
          </div>
          <div className="flex items-center gap-4 text-white/80">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" className="hover:text-[#C5A059] transition-colors">
              <Instagram size={20} strokeWidth={1.5} />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" className="hover:text-[#C5A059] transition-colors">
              <Facebook size={20} strokeWidth={1.5} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
